// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mailing_wrapper__YSNvo","content":"mailing_content__3l6E6","contentBlocks":"mailing_contentBlocks__18wkg"};